import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms'
import { AuthService } from '../auth.service'
import { AlertService } from '../../services/alert.service'
import { PasswordValidation } from '../change-password/password-validation'
import { BaseService } from 'app/services/base.service';
import { Router } from '@angular/router';
import { Http } from '@angular/http';


@Component({
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {
  public isRequesting: boolean = false;
  public isSubmitted: boolean = false;
  public model: { password: '' };
  form: FormGroup;
  constructor(private router: Router,
              private authService: AuthService,
              private formBuilder: FormBuilder,
              private alertService: AlertService,
              private baseService: BaseService
           ) {
    
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    }, { validator: PasswordValidation.MatchPassword });

  }

  changePassword(value, valid: boolean) {
    this.isRequesting = true;
    if (valid) {
      this.authService.changePassword(value)
      .catch(this.baseService.handleError)
      .finally(() => this.isRequesting = false)
      .subscribe(data => {  this.alertService.success("Password successfully changed");},
                 error => { this.alertService.error(error)});
    }
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/change-password/change-password.component.ts